import { HTMLAttributes, LabelHTMLAttributes, PropsWithChildren } from "react";
import { twMerge } from "tailwind-merge";
import { PropsWithClassAndStyle } from "utils/props";

export function FormField({ name, children, className, style, required }: PropsWithClassAndStyle<PropsWithChildren<{ name: string; required?: boolean }>>) {
  return <div className={className} style={style}>
    <h4 className="font-semibold mb-1 text-sm uppercase">
      {name}
      {required && <span className="text-normal text-red-600"> *</span>}
    </h4>
    {children}
  </div>
}

export function FormFieldNative({ name, children, className, style, required, htmlFor, ...props }: LabelHTMLAttributes<HTMLLabelElement> & { name: string; required?: boolean }) {
  return <label className={className}  {...props}>
    <div className="font-semibold w-max text-sm uppercase mb-1">
      {name}
      {required && <span className="text-normal text-red-600"> *</span>}
    </div>
    {children}
  </label>
}

